import { isArray } from 'util';
import { OperationMode } from '../operation-mode';

export class OperationModeBuilder {
  static fromJson(json) {
    return (json)
      ? new OperationMode(
        json.hash,
        json.name,
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(OperationModeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operation-mode.builder.ts